module.exports = __webpack_public_path__ + "static/media/blueskyai-white.282c0771.png";